import "../scss/style.scss";
import $ from 'jquery';
import 'jquery-match-height';
import 'lity';
import 'magnific-popup';

jQuery(function ($) {

	// smooth scroll
	$(function () {
		var urlHash = location.hash;
		if (urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(function() {
				var target = $(urlHash);
				var position = target.offset().top;
				$('body,html').stop().animate({
					scrollTop: position
				}, 500);
			}, 100);
			return false;
		}
		$('a[href^="#"]').on('click', function() {
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
			return false;
		});
	});

  // SP nav
	$(function () {
		$('.js-nav-bt').on('click', function () {
			if ($('.js-nav-content').hasClass('is_open')) {
				$(".js-nav-content").removeClass('is_open');
				$(".header__bg").removeClass('is_open');
				$(this).removeClass('is_open');
			} else {
				$(".js-nav-content").addClass('is_open');
				$(".header__bg").addClass('is_open');
				$(this).addClass('is_open');
			}
		});
		$('.js-nav-bt.close, .header__bg, .js-nav-content a').on('click', function () {
			$(".js-nav-content, .js-nav-bt.is_open, .header__bg.is_open").removeClass('is_open');
		});
	});

	var scroll, btnFixedLeft, btnAbsoluteLeft, btnWidth, btnOuterWidth, commonFooter, objTop, windowWidth, wrapper;
	$(window).on('load scroll resize', function(){
		objTop = $('.wrapper').offset().top;
		commonFooter = $('#suntoryCommonFooter').offset().top - 70;
		btnAbsoluteLeft = $('.wrapper').width() - 65;
		btnFixedLeft = ($(window).width() / 2) - ($('.wrapper').width() / 2) + btnAbsoluteLeft;
		scroll = $(window).scrollTop();
		if(scroll >= commonFooter) {
			$('.js-nav-bt').removeClass('is_scrolling').addClass('is_footer').css({left: btnAbsoluteLeft});
			$('.js-nav-content').removeClass('is_scrolling').addClass('is_footer');
		} else if(scroll >= objTop){
			$('.js-nav-bt').addClass('is_scrolling').removeClass('is_footer').css({left: btnFixedLeft});
			$('.js-nav-content').addClass('is_scrolling').removeClass('is_footer');
		} else {
			$('.js-nav-bt').removeClass('is_scrolling').css({left: btnAbsoluteLeft});
			$('.js-nav-content').removeClass('is_scrolling');
		}
	});

	// to top
	$(document).ready(function () {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 200) {
				$(".js-toTop").addClass('on');
			} else {
				$(".js-toTop").removeClass('on');
			}
		});
	});

	// pull down
  $(function(){
    $('.js-matchheight').matchHeight();
  });

	$('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,
    showCloseBtn: true,
    fixedContentPos: true,
	});

  $('.js-popup-close').on('click',function(){
    $('.popup-modal').magnificPopup('close');
  });

  // scroll animation
  $(document).on('load scroll', function () {
    $('.js-fadeUp').each(function () {
			var targetElement = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > targetElement - windowHeight + 100){
				$(this).addClass('scrollin');
			}
			else {
				$(this).removeClass('scrollin');
			}
		});
  });

});
